import Header from "../../headerAuthenticated/HeaderAuthenticated.vue"
import ResponsiveFooter from "../..//responsivefooter/ResponsiveFooter.vue"
import TitleBox from "../TitleBox/TitleBox.vue"
import Portfolio from "../Portfolio/Portfolio.vue"
import Performance from "../Performance/Performance.vue"
import Diversification from "../Diversification/Diversification.vue"
import SettingsPortfolio from "../SettingsPortfolio/SettingsPortfolio.vue"
import '..//..//..//mixins.js'
import {mapActions} from 'vuex'
import spinner from "../../LoadingComponent/LoadingComponent.vue"
import SideBar from "../../SideBar/SideBar.vue"
import CookieLaw from 'vue-cookie-law'

export default {
  name: 'portfolio-dashboard',
  components: {
    Header: Header,
    responsivefooter: ResponsiveFooter,
    Portfolio: Portfolio,
    Performance: Performance,
    Diversification: Diversification,
    TitleBox: TitleBox,
    settingsportfolio: SettingsPortfolio,
    spinner,
    SideBar,
    CookieLaw
  },
  props: [],
  data () {
    return {
      tokenValid:false,
      showPortfolio:null,
      portfolio_id:this.$route.params.PORTFOLIO_ID,
      isDataLoaded: false,
      isEndpointError: false,
    }
  },
  computed: {

  },
  async created () {
    this.showPortfolio = await this.accessEndpoint("portfolio/?format=json&portfolio_id=" + this.portfolio_id);
    if (/*this.showPortfolio == true && */this.tokenValid == true){
      try{
        window.addEventListener("resize", this.myEventHandler);
        await this.$store.dispatch('load_PD_userData', this.portfolio_id)
        this.isDataLoaded = true;
      }catch{
        this.showErrorNotification();
      }

    }
    else if (this.showPortfolio == false){
      this.$router.push("/portfolios");
    } 
  },
  
  mounted () {

  },
  methods: {
    ...mapActions(['load_PD_userData']),
  }
}


